import { useCallback } from "react";
import { useSearchParams } from "react-router";
import { useTranslation } from "react-i18next";
import { TitledTabs, TabSpec } from "components/common/titledTabs";
import { SelectTenantPage } from "components/settings/SelectTenantPage";
import { ScrapReportPage } from "components/scrapReport/ScrapReportPage";

type MissionControlPageTab = "home" | "scrapReports";

const VALID_TABS: Set<string> = new Set<string>(["home", "scrapReports"]);

export const MissionControlTabbedPage = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get("tab");
  const activeTab: MissionControlPageTab =
    tabParam && VALID_TABS.has(tabParam)
      ? (tabParam as MissionControlPageTab)
      : "home";

  const handleTabChange = useCallback(
    (tab: MissionControlPageTab) => {
      if (tab === "home") {
        setSearchParams({});
      } else {
        setSearchParams({ tab });
      }
    },
    [setSearchParams]
  );

  const tabSpecs: TabSpec<MissionControlPageTab>[] = [
    { title: t("home"), key: "home", content: <SelectTenantPage /> },
    {
      title: t("scrapReport"),
      key: "scrapReports",
      content: <ScrapReportPage />,
    },
  ];

  return (
    <TitledTabs
      tabSpecs={tabSpecs}
      selectedTabKey={activeTab}
      onChange={handleTabChange}
    />
  );
};
